<template>
    <div class="property-tourcta">
        <div class="text-bold">Request a virtual or in-person tour</div>
        <div>
            <button type="button" @click="openTourHotlead('asap')" :class="{ active: tourChoice === 'asap' }">
                <span class="f6">Tour</span>
                <span class="text-bold f4">ASAP</span>
            </button>
            <button type="button" @click="openTourHotlead('weekend')" :class="{ active: tourChoice === 'weekend' }">
                <span class="f6">Tour</span>
                <span class="text-bold f4">This weekend</span>
            </button>
            <button type="button" @click="openTourHotlead('another')" :class="{ active: tourChoice === 'another' }">
                <span class="f6">Tour</span>
                <span class="text-bold f4">Another time</span>
            </button>
        </div>
    </div>
</template>

<script src="./property-tourcta.js"></script>


<style lang="scss">
@use "./property-tourcta.scss" as *;
</style>
